export default {
  namespaced: true,
  inventory_project_catalog: {
    menu: "Catálogo de Proyectos",
    title: "Proyecto",
    project_id: "ID del Proyecto",
    test: "ID del Proyecto",
    name: "Nombre",
    created_at: "Creado",
    updated_at: "Actualizado",
  },
};
